import BaseView from './base';

export default class MatrixColumnView extends BaseView {
    constructor(matrix, column) {
        super(matrix, matrix.rows, 1);
        this.column = column;
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(rowIndex, this.column, value);
        return this;
    }

    get(rowIndex) {
        return this.matrix.get(rowIndex, this.column);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression-robust-polynomial/~/ml-matrix/src/views/column.js
// module id = 221
// module chunks = 0